export default function AmbuSeva_Partner_Tnc() {
    return (
        <>
            <meta charSet="utf-8" />
            <p>AmbuSeva Partner App Terms &amp; Conditions</p>
            <p>
                Matri Mission 'O' Mandir Seva Trust - AmbuSeva Partner (Ambulance Owner /
                Operator) App Terms &amp; Conditions
            </p>
            <p>Last Updated: 22nd Jan 2026.</p>
            <br />
            <h3>IMPORTANT LEGAL NOTICE</h3>
            <p>
                These Partner Terms &amp; Conditions ("Agreement") govern the relationship
                between Matri Mission 'O' Mandir Seva Trust AmbuSeva Partner App
                ("Platform") and registered ambulance owners, operators or fleet partners
                ("Partner", "you"). By registering or maintaining an active Partner account,
                you accept and agree to be bound by this Agreement. If you do not agree, do
                not register with us on the Partner App.
            </p>
            <br />
            <h3>1. DEFINITIONS</h3>
            <p>
                1.1 "Partner Services" means ambulance and related medical transport
                services provided by the Partner using ambulances, drivers, medical
                attendants, and medical equipment.
            </p>
            <p>
                1.2 "Net Settlement" means payment to Partner after deduction of Platform
                fees, penalties, chargebacks and other adjustments.
            </p>
            <p>
                1.3 "Service Failure" means non-performance or substandard performance by
                Partner that violates applicable laws, regulations, or Platform standards.
            </p>
            <br />
            <h3>2. RELATIONSHIP &amp; INDEPENDENT CONTRACTOR STATUS</h3>
            <p>
                2.1 The Partner is an independent contractor. Nothing in this Agreement
                shall create an employment, agency, joint venture, or partnership
                relationship between the Partner and the Platform.
            </p>
            <p>
                2.2 Partners are responsible for all statutory obligations towards their
                employees, contractors, and medical staff, including taxes, insurance, and
                statutory benefits.
            </p>
            <br />
            <h3>3. ELIGIBILITY, DOCUMENTATION &amp; ONBOARDING</h3>
            <p>
                3.1 Eligibility: Partner must be legally authorised to provide ambulance
                services, own or lease ambulances, maintain valid registration, permits, and
                comply with state and national health and transport regulations.
            </p>
            <p>
                3.2 Documentation: Partners must provide accurate documentation including
                vehicle registration, insurance certificates, driver licenses, medical
                personnel qualifications, pollution control certificates, operating permits,
                and copies of applicable licenses.
            </p>
            <p>
                3.3 Background Checks &amp; Training: Partners shall ensure background
                checks for drivers and medical staff and provide reasonable training in
                emergency protocols, infection control, and patient handling.
            </p>
            <br />
            <h3>4. SERVICE STANDARDS &amp; OPERATIONS</h3>
            <p>
                4.1 Equipment &amp; Maintenance: Vehicles used for Partner Services must be
                in safe working condition and equipped with required medical equipment as
                per applicable law and Platform minimum standards.
            </p>
            <p>
                4.2 Staffing: Partners shall ensure at least one driver and such medical
                personnel as appropriate for the level of service committed in the booking (e.g., Basic Life Support,
                Advanced Life Support).
            </p>
            <p>
                4.3 Compliance: Partners must comply with all
                applicable laws including motor vehicle laws, public health laws, biomedical
                waste rules where applicable, and all regulatory requirements in the
                jurisdiction of operation.
            </p>
            <br />
            <h3>5. BOOKINGS, ACCEPTANCE &amp; ALLOCATION</h3>
            <p>
                5.1 Booking Acceptance: Drivers associated with partners may accept or
                decline ride requests through the AmbuSeva Driver App. Rejection or failure
                to attend accepted bookings may lead to penalties, suspension, or
                termination in accordance with Platform policies.
            </p>
            <p>
                5.2 Dispatching &amp; Routing: Drivers associated with partners will
                cooperate with the Platform's dispatching mechanisms and facilitate
                real-time communication and GPS tracking for operational efficiency and
                user safety.
            </p>
            <br />
            <h3>6. PRICING, BILLING, SETTLEMENTS &amp; TAXES</h3>
            <p>
                6.1 Pricing Policy: The Platform may define fare structures, suggested
                pricing, or fixed pricing, or dynamic pricing, and/or deduct applicable
                service charge required to maintain the Platform. Partner agrees to the fare
                model communicated by the Platform or as otherwise agreed.
            </p>
            <p>
                6.2 Settlement Cycle: Net Settlements to Partners will be processed monthly
                (or as otherwise provided) subject to verification, dispute resolution and
                applicable deductions.
            </p>
            <p>
                6.3 Taxes &amp; Deductions: Partners are responsible for paying all taxes
                arising from their operations. The Platform will not withhold tax amounts.
            </p>
            <br />
            <h3>7. INSURANCE &amp; RISK MANAGEMENT</h3>
            <p>
                7.1 Minimum Insurance: Partners must maintain adequate insurance including
                third-party motor insurance, passenger liability (where applicable),
                healthcare professional indemnity for medical staff, and other insurances
                required by law.
            </p>
            <p>
                7.2 Evidence of Insurance: Partners shall furnish proof of insurance upon
                onboarding and upon renewal. Failure to maintain valid insurance may result
                in suspension or termination.
            </p>
            <p>
                7.3 Incident Reporting: Partners must promptly report accidents, medical
                incidents, patient complaints, or regulatory investigations to the Platform
                and cooperate in any investigation.
            </p>
            <br />
            <h3>8. SAFETY &amp; PATIENT CARE</h3>
            <p>
                8.1 Duty of Care: Drivers and their Partners acknowledge responsibility for
                patient safety while under their care. Medical protocols, infection
                control, patient dignity, confidentiality and restraint of unnecessary
                force must be followed.
            </p>
            <p>
                8.2 Medical Decision-Making: Medical personnel assigned to Partner Services
                shall exercise independent clinical judgment. The Platform does not
                supervise or direct medical treatment.
            </p>
            <p>
                8.3 Emergency Preparedness: Drivers associated with Partners and/or Partners
                shall maintain contingency plans for vehicle breakdowns, staff shortages,
                adverse weather, and public health emergencies.
            </p>
            <br />
            <h3>9. DATA &amp; PRIVACY</h3>
            <p>
                9.1 Data Processing: Drivers associated with Partners will receive the
                minimum necessary data to perform booked services (e.g., patient name,
                pickup location, emergency contact) in the AmbuSeva Driver App. Drivers
                associated with Partners must process such data in accordance with the
                Platform's Privacy Policy and applicable data protection law.
            </p>
            <p>
                9.2 Confidentiality: Drivers associated with Partners and/or Partners agrees
                to maintain confidentiality of Platform data, patient information, and any
                proprietary operational details provided by the Platform.
            </p>
            <br />
            <h3>10. PERFORMANCE STANDARDS, AUDIT &amp; TERMINATION FOR CAUSE</h3>
            <p>
                10.1 Performance Metrics: Platform may set performance indicators (e.g.,
                response time, completion rate) and may implement graduated penalties for
                non-compliance.
            </p>
            <p>
                10.2 Audits: Platform reserves the right to audit Partner records, vehicles
                and processes to ensure compliance with this Agreement and applicable law.
            </p>
            <p>
                10.3 Termination: Platform may suspend or terminate the Agreement for cause,
                including fraud, gross negligence, repeated service failure, regulatory
                non-compliance, or reputational harm.
            </p>
            <br />
            <h3>11. PAYMENT DISPUTES &amp; RECONCILIATION</h3>
            <p>
                11.1 Dispute Resolution for Payments: Partners should raise payment disputes
                within 10 days of settlement. Disputes not raised within the stipulated time
                frame may be deemed waived, while provision for exemptions due to unforeseen
                circumstances may be allowed by the platform as per its discretion.
            </p>
            <p>
                11.2 Reconciliation: Platform will provide settlement statements and
                supporting data for verification. The Platform reserves the right to
                withhold disputed amounts pending investigation.
            </p>
            <br />
            <h3>12. INDEMNITY &amp; LIMITATION OF LIABILITY</h3>
            <p>
                12.1 Indemnity by Partner: Partner shall indemnify and hold the Platform
                harmless from any claims, liabilities, penalties, fines or losses arising
                from Partner's operation, breach of this Agreement, negligence, wilful
                misconduct or failure to comply with laws.
            </p>
            <p>
                12.2 Limitation of Platform Liability: TO THE MAXIMUM EXTENT PERMITTED BY
                LAW, THE PLATFORM SHALL NOT BE LIABLE FOR INDIRECT, INCIDENTAL,
                CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING FROM PARTNER SERVICES. NOTHING
                HEREIN SHALL LIMIT LIABILITY FOR FRAUD, WILLFUL MISCONDUCT OR WHEN LIABILITY
                CANNOT BE EXCLUDED BY LAW.
            </p>
            <br />
            <h3>13. INTELLECTUAL PROPERTY &amp; LICENSING</h3>
            <p>
                13.1 Limited License: Platform grants Partner a limited, revocable,
                non-exclusive license to use the AmbuSeva Partner App and the Drivers
                associated with Partners a limited, revocable, non-exclusive license to use
                the AmbuSeva Driver App and related materials solely for the purpose of
                providing Partner and Driver Services as contemplated by this Agreement.
            </p>
            <p>
                13.2 Feedback: Any suggestions, enhancements, or improvements provided by
                Partner may be used by the Platform without obligation.
            </p>
            <br />
            <h3>14. INSOLVENCY, ASSIGNMENT &amp; CHANGE OF CONTROL</h3>
            <p>
                14.1 Assignment: Partner shall not assign this Agreement without the prior
                written consent of the Platform. The Platform may assign its rights to any
                affiliated entity.
            </p>
            <p>
                14.2 Insolvency: In the event of insolvency, bankruptcy or cessation of
                business by Partner, the Platform may immediately suspend or terminate
                Partner access.
            </p>
            <br />
            <h3>15. FORCE MAJEURE &amp; PANDEMIC CLAUSE</h3>
            <p>
                15.1 Force Majeure: Neither party shall be liable for failure or delay
                caused by events beyond its reasonable control including natural disasters,
                war, acts of terrorism, strikes, governmental actions, epidemics, pandemics,
                lockdowns, or public health emergencies.
            </p>
            <p>
                15.2 Operational Adjustments: During a Force Majeure Event, Partners shall
                notify the Platform of any anticipated service disruptions and cooperate in
                mutually agreeable operational adjustments. </p>
            <p>15.3 Relief: The Platform may
                temporarily suspend obligations, adjust settlement cycles, or revise service
                standards during a Force Majeure Event without liability.
            </p>
            <br />
            <h3>16. COMPLIANCE WITH LAWS</h3>
            <p>
                16.1 Compliance: Partner shall comply with all applicable laws, regulations
                and guidelines including healthcare regulations, motor vehicle rules, data
                protection laws, anti-bribery and anti-corruption laws.
            </p>
            <br />
            <h3>17. DISPUTE RESOLUTION</h3>
            <p>
                17.1 Good Faith Negotiation: Parties shall attempt to resolve disputes
                amicably through negotiation.
            </p>
            <p>
                17.2 Disputes shall be subject to the exclusive jurisdiction of the courts
                located in Kalyani, India.
            </p>
            <br />
            <h3>18. MISCELLANEOUS</h3>
            <p>
                18.1 Entire Agreement: This Agreement constitutes the entire understanding
                between the parties, that is the platform and partner along with the associated drivers.
            </p>
            <p>
                18.2 Notices: Notices shall be sent to the contact details provided in the
                Partner App or to the registered business address or the email address or
                communicated to via mobile phone number.
            </p>
            <p>
                18.3 Amendments: Platform may amend terms with notice. Continued use after
                notice constitutes acceptance.
            </p>
            <br />
            <h3>19. CONTACT INFORMATION</h3>
            <p>Matri Mission 'O' Mandir Seva Trust</p>
            <p>Address: A-9/155, Kalyani, Nadia, West Bengal, India, 741235.</p>
            <p>Email: info@mail.matrimission.org</p>
            <p>Phone: +91 70594 28773</p>
            <p>Website: <a href="https://www.matrimission.org">www.matrimission.org</a></p>
        </>
    );
}
